import React, { Component } from 'react';
import { Navigate } from "react-router-dom";
import Grid from '@mui/material/Grid2';

import { ModelBase, PlayerObject } from "@models";

import API from "@dndUtilities/system_api";

import ObjectIndex from "@components/Navigation/ObjectIndex";
// import FilterBox from '../../components/FilterBox';
import DisplayObjects from "@dndComponents/display/DisplayObjects";
import { Character } from '@dndModels';

type Props = { }

export interface State { 
  navigateTo: string | null;
  logging_in: boolean;
  processing: boolean;
}

const api = API.getInstance();

class AllCharacters extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      navigateTo: null,
      logging_in: false,
      processing: false
    };
  }

  componentDidMount() {
    if (api.user === null) {
      const userObjStr = localStorage.getItem("loginUser");
      if (!userObjStr) {
        this.setState({ navigateTo: "/" });
      } else {
        this.setState({ logging_in: true }, this.check_login);
      }
    } else if (!api.user.admin) {
      this.setState({ navigateTo: "/" });
    }
  }

  check_login() {
    setTimeout(() => {
      if (api.user === null) {
        this.check_login();
      } else if (!api.user.admin) {
        this.setState({ navigateTo: "/" });
      } else {
        this.setState({ logging_in: false });
      }
    }, 1000);
  }

  get_filter() {
    const new_filter: any = {};
    
    const search_string = api.search_string;
    if (search_string !== "") {
      // filter.search_string = search_string;
      new_filter["$or"] = [{ "name*includes": search_string },{ "description*includes": search_string }];
    }
    const owner_id = api.get_filter("user");
    if (Object.keys(owner_id).length > 0) {
      new_filter.owner_id = owner_id;
    }
    const campaign_id = api.get_filter("campaign");
    if (Object.keys(campaign_id).length > 0) {
      new_filter.campaign_id = campaign_id;
    }

    return new_filter;
  }

  render() {
    if (this.state.navigateTo !== null) {
      return <Navigate to={this.state.navigateTo} />;
    } else if (this.state.logging_in) {
      return <span>Logging In</span>;
    } else if (api.user === null) {
      return <Navigate to="/" />;
    } else if (!api.online) {
      return (
        <>Only personal characters available when offline.</>
      );
    } else {
      return (
        <Grid container spacing={0} direction="column">
          {/* <Grid item container spacing={0} direction="row">
            <Grid item xs={3}>
              <span className="header">
                All Characters
              </span>
            </Grid>
            <Grid item xs={9}>
              <FilterBox 
                fields={["user","campaign"]}
                onChange={() => {
                  this.setState({ });
                }}
              />
            </Grid>
          </Grid> */}
          <Grid>
            <ObjectIndex 
              data_type="character"
              // filter={this.get_filter()}
              extra={(obj) => {
                if (obj instanceof Character) {
                  return <DisplayObjects type="user" ids={[obj.owner_id]} />;
                }
                return null;
              }}
              // show_owners
              exclude_options={["Edit"]}
            />
          </Grid>
        </Grid>
      ); 
    } 
  }
}

export default AllCharacters;
